export const searchData = (manager) => {
  manager.grouped = manager.treefied = manager.sorted = manager.paged = false;

  manager.searchedData = [...manager.filteredData];

  if (manager.searchText && manager.applySearch) {
    const trimmedSearchText = manager.searchText.trim();
    manager.searchedData = manager.searchedData.filter((row) => {
      return manager.columns
        .filter((columnDef) => {
          return columnDef.searchable === undefined
            ? !columnDef.hidden
            : columnDef.searchable;
        })
        .some((columnDef) => {
          // console.log(columnDef.customFilterAndSearch)
          if (columnDef.customFilterAndSearch) {
            return !!columnDef.customFilterAndSearch(
              trimmedSearchText,
              row,
              columnDef
            );
          } else if (columnDef.field) {
            const value = manager.getFieldValue(row, columnDef);

            if (columnDef.children && columnDef.children.length > 0) {
              return columnDef.children.some((c) => {
                const innerValue = row[c.id_a];
                let found = false;
                if (innerValue) {
                  found = innerValue
                    .toString()
                    .toUpperCase()
                    .includes(trimmedSearchText.toUpperCase());
                }
                return found;
              });
            }
            if (value) {
              return value
                .toString()
                .toUpperCase()
                .includes(trimmedSearchText.toUpperCase());
            }
          }
        });
    });
  }
  manager.searched = true;
  return;
};

export function calcularOpcionesPageSize(
  pageSize,
  cantdd_registros_max = 30,
  initPageSize
) {
  if (typeof cantdd_registros_max === "string") {
    cantdd_registros_max = parseInt(cantdd_registros_max);
  }

  let opciones = [pageSize, 5, 10, 20];

  if (!isNaN(initPageSize) && pageSize !== Number(initPageSize)) {
    opciones.push(Number(initPageSize));
  }

  if (!isNaN(cantdd_registros_max)) {
    opciones.push(cantdd_registros_max);
  } else {
    opciones.push(30);
  }

  opciones = opciones.filter(
    (valor, indice) => opciones.indexOf(valor) === indice
  );
  // opciones = opciones.filter((v) => v <= pageSize);
  opciones = opciones.sort((a, b) => a - b).filter((f) => f);

  const setOpciones = new Set(opciones);

  return Array.from(setOpciones);
}

export function updateSelectedArray(selected, row) {
  row = row.filter((obj) => {
    const k = Object.keys(obj).filter((k) =>
      k.endsWith("listado_seleccion_habilitado")
    )[0];
    if (!k) return true;
    return obj[k] === 1;
  });

  if (!selected) {
    return row;
  }
  let newSelected = [...selected];

  const isTodosPresentes = row.every((itemToCheck) =>
    selected.some(
      (referenceItem) => referenceItem.tableData.id === itemToCheck.tableData.id
    )
  );

  if (isTodosPresentes) {
    row.forEach((rowItem) => {
      newSelected = newSelected.filter(
        (ns) => ns.tableData.id !== rowItem.tableData.id
      );
    });

    return newSelected;
  }

  row.forEach((rowItem) => {
    const index = newSelected.findIndex(
      (selectedItem) => selectedItem.tableData.id === rowItem.tableData.id
    );

    if (index === -1) {
      newSelected.push(rowItem);
    } else {
      // newSelected.splice(index, 1);
    }
  });

  return newSelected;
}

export function parseSelectedData(cabeceras, rowState, opcionesListado) {
  const ida_solicitados = opcionesListado.listado_seleccion_data?.split("|");

  let datoRequerido = { _key: rowState._key };
  if (ida_solicitados) {
    ida_solicitados.forEach((ida) => {
      const cabecera = cabeceras.find((cab) => cab.id_a === ida);
      datoRequerido[ida] = rowState[ida];

      if (cabecera.clave_envio && cabecera.clave_envio.trim() !== "") {
        datoRequerido[cabecera.clave_envio.trim()] = rowState[ida];
      }

      // enviar contenido del label seleccionado en componentes con opciones
      if (cabecera.opciones) {
        datoRequerido[ida + "_label"] = cabecera.opciones
          .filter((op) => op.value === rowState[ida])
          .pop().label;
        if (cabecera.clave_envio && cabecera.clave_envio.trim() !== "") {
          datoRequerido[cabecera.clave_envio.trim() + "_label"] =
            datoRequerido[ida + "_label"];
        }
      }
    });
  }

  return datoRequerido;
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
